export const FINANCE_PATH = "/user-profile/finance"

export const SUBSCRIPTION_SURFACE_PATH = `${FINANCE_PATH}/subscription`

/** Search params of the subscription page; they live in the URL, so a reload lands on the same grid and tier. */
export const SUBSCRIPTION_SURFACE_PARAMS = {
  grid: "grid",
  tier: "tier",
  scope: "scope"
} as const

/** `scope` value of a page opened from a chat screen: it follows the selected chat's grid. */
export const SUBSCRIPTION_SURFACE_CHAT_SCOPE = "chat"

export interface SubscriptionSurfaceLinkOptions {
  /** Grid to show instead of the viewer's own (grid-detail deep link). */
  gridId?: string | null
  /** Tier to pre-select (wizard return). */
  tier?: string | null
  /** Opened from a chat screen: show the selected chat's grid rather than the viewer's own. */
  followsChat?: boolean
}

export const buildSubscriptionSurfacePath = ({
  gridId,
  tier,
  followsChat = false
}: SubscriptionSurfaceLinkOptions = {}): string => {
  const params = new URLSearchParams()
  if (gridId) params.set(SUBSCRIPTION_SURFACE_PARAMS.grid, gridId)
  if (tier) params.set(SUBSCRIPTION_SURFACE_PARAMS.tier, tier)
  if (followsChat) params.set(SUBSCRIPTION_SURFACE_PARAMS.scope, SUBSCRIPTION_SURFACE_CHAT_SCOPE)
  const search = params.toString()
  return search ? `${SUBSCRIPTION_SURFACE_PATH}?${search}` : SUBSCRIPTION_SURFACE_PATH
}
